import e from"../../../node_modules/jwt-decode/build/jwt-decode.esm.js";var o=function(){return Date.now()/1e3},t=function(t){if(t){var r=void 0;try{r=e(t)}catch(e){}if(r)return r.exp>o()?r:void 0}};export{o as getTime,t as jwt};
